import { useGetMyEstimatesQuery } from '@massilia/queries'
import { createFileRoute, Link, Outlet } from '@tanstack/react-router'

import { ClientHero } from '@/components/client-nav/client-hero'
import { ClientNav } from '@/components/client-nav/client-nav'

export const Route = createFileRoute('/_authenticated/_layout')({
  component: ClientAreaLayout,
})

export function ClientAreaLayout() {
  // Propositions qui attendent une réponse du client, toutes demandes
  // confondues : c'est la pastille de l'onglet Devis. La requête est la même
  // que celle de l'onglet, servie depuis le cache une fois chargée.
  const { data: estimateGroups = [] } = useGetMyEstimatesQuery()
  const pendingQuotesCount = estimateGroups
    .flatMap((group) => group.responses)
    .filter((response) => response.canAct).length

  return (
    <div className="flex min-h-screen w-full flex-col">
      {/* Collante : l'espace client se parcourt en listes longues (devis,
          dossiers, formulaire de réservation) — la navigation et la
          déconnexion doivent rester à portée sans remonter en haut de page. */}
      <header className="sticky top-0 z-40 flex items-center justify-between gap-4 border-b border-gray-light-200 bg-white px-6 py-2 md:px-28">
        <Link to="." href="https://wp.massiliavoyages.fr/">
          <img alt="Massilia Voyages" className="h-9 md:h-12" src="/logos/massilia-logo.png" />
        </Link>
        <ClientNav pendingQuotesCount={pendingQuotesCount} />
      </header>
      <ClientHero />
      <Outlet />
    </div>
  )
}
